(() => {
  const dialog = document.getElementById('gg-signup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const completedKey = 'goodgirl-signup-completed';
  const dismissedKey = 'goodgirl-signup-dismissed-until';
  const pendingKey = 'goodgirl-signup-pending';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
  let previousFocus;
  let timer;
  let readyAt = 0;
  let dismissed = false;
  let yieldingToVerification = false;
  const stopWaiting = () => {
    clearTimeout(timer);
    document.removeEventListener('pointerdown', begin);
    document.removeEventListener('keydown', begin);
    document.removeEventListener('scroll', begin);
    document.removeEventListener('visibilitychange', showWhenReady);
  };
  const open = () => {
    if (dialog.open || document.querySelector('dialog[open]')) return false;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('gg-signup-open');
    dialog.querySelector('h2')?.focus({ preventScroll: true });
    return true;
  };
  const showWhenReady = () => {
    if (!readyAt || dismissed || document.visibilityState !== 'visible') return;
    if (Date.now() < readyAt) {
      clearTimeout(timer);
      timer = setTimeout(showWhenReady, readyAt - Date.now());
      return;
    }
    if (document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) {
      timer = setTimeout(showWhenReady, 5000);
      return;
    }
    if (open()) stopWaiting();
  };
  function begin() {
    document.removeEventListener('pointerdown', begin);
    document.removeEventListener('keydown', begin);
    document.removeEventListener('scroll', begin);
    readyAt = Date.now() + 12000;
    timer = setTimeout(showWhenReady, 12000);
  }
  dialog.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    if (yieldingToVerification) {
      yieldingToVerification = false;
      return;
    }
    dismissed = true;
    stopWaiting();
    document.documentElement.classList.remove('gg-signup-open');
    write('localStorage', dismissedKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
    if (previousFocus?.isConnected && !document.querySelector('dialog[open]')) previousFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !dialog.matches(':modal')) {
      event.preventDefault();
      dialog.close();
    }
  });
  const consent = form.querySelector('[name="contact[accepts_marketing]"]');
  const consentError = form.querySelector('[data-signup-consent-error]');
  if (consent && consentError) {
    consent.addEventListener('invalid', event => {
      // Keep native required validation, but show an accessible branded message.
      event.preventDefault();
      consentError.hidden = false;
      consent.setAttribute('aria-invalid', 'true');
      if (form.querySelector('input[type="email"]')?.validity.valid) consent.focus();
    });
    consent.addEventListener('change', () => {
      if (!consent.checked) return;
      consentError.hidden = true;
      consent.removeAttribute('aria-invalid');
    });
  }
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    write('sessionStorage', pendingKey, String(Date.now()));
    // Shopify's verification iframe lives outside this dialog. Leave the
    // browser's modal top layer so its challenge stays visible and usable.
    // Keep the form available if the visitor cancels that challenge.
    if (dialog.open) {
      yieldingToVerification = true;
      dialog.close();
      dialog.show();
    }
  });
  const success = Boolean(dialog.querySelector('[data-signup-success]'));
  const error = Boolean(dialog.querySelector('[data-signup-errors]'));
  const pending = Number(read('sessionStorage', pendingKey)) > Date.now() - 30 * 60 * 1000;
  if (success) {
    write('localStorage', completedKey, 'true');
    remove('sessionStorage', pendingKey);
    if (pending || location.hash === '#gg-signup-form') open();
    return;
  }
  if (error && (pending || location.hash === '#gg-signup-form')) {
    open();
    dialog.querySelector('[aria-invalid="true"]')?.focus();
    return;
  }
  if (dialog.dataset.signupAuto !== 'true' || window.Shopify?.designMode || read('localStorage', completedKey) === 'true' || Number(read('localStorage', dismissedKey)) > Date.now()) return;
  document.addEventListener('pointerdown', begin, { passive: true });
  document.addEventListener('keydown', begin);
  document.addEventListener('scroll', begin, { passive: true });
  document.addEventListener('visibilitychange', showWhenReady);
})();

